import Customer from './customer';
import WarehouseInventoryItem from './warehouseinventoryitem';

class Warehouse {
    constructor(json) {
        if (json) {
            this.clusterId = json.clusterId;
            this.name = json.name;
            this.id = json.id;
            this.insertUserId = json.insertUserId;
            this.updateUserId = json.updateUserId;
            this.isVirtual = json.isVirtual;
            this.allowOrderFrom = json.allowOrderFrom;
            this.allowOrderTo = json.allowOrderTo;
            this.users = json.users;
            this.inventory = [];
            if (json.customer) this.customer = new Customer(json.customer);

            if (json.inventory && json.inventory.length) {
                for (let item of json.inventory) {
                    this.inventory.push(new WarehouseInventoryItem(item));
                }
            }
        } else {
            this.clusterId = 0;
            this.id = 0;
            this.name = '';
            this.insertUserId = null;
            this.updateUserId = null;
            this.isVirtual = null;
            this.allowOrderFrom = null;
            this.allowOrderTo = null;
            this.customer = null;
            this.users = [];
            this.inventory = [];
        }
    }
}

export default Warehouse;
